export default __webpack_public_path__ + "static/media/articles.81012579.jpg";